import script from "./ItemQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemQuantity.vue?vue&type=script&setup=true&lang=js"

import "./ItemQuantity.vue?vue&type=style&index=0&id=932e9e7a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932e9e7a"]])

export default __exports__